import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useLocalStorage("user", null);
    const [currentApp, setCurrentApp] = useLocalStorage("currentApp", null);

    const navigate = useNavigate();

    // call this function when you want to authenticate the user
    const login = async (userData) => {
        setUser(userData);
        setCurrentApp({ tenantId: userData.data.tenantId, appId: userData.currentAppId });
        navigate("/");
    };

    // call this function to sign out logged in user
    const logout = (redirect) => {
        setUser(null);
        //setAppIds(null);

        if (redirect === undefined || redirect === true)
            navigate("/", { replace: true });
    };

    const value = useMemo(
        () => ({
            user,
            currentApp,
            login,
            logout,
        }),
        [user, currentApp]
    );
    
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};

export default AuthProvider;